import { cn } from '@/app/_shared/lib/utils';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
    return <div className={cn('bg-accent animate-pulse rounded-md', className)} {...props} />;
}

export { Skeleton };
